import { Card } from 'react-bootstrap'

export function CardSimple({icon = null, title, texts = false, numbers = false}) {

    return (
        <Card className='card-simple h-100 w-100'>
            <Card.Body>
                <Card.Title className="d-flex align-items-center gap-2">{icon && <img src={icon} alt="icon" />} {title}</Card.Title>
                <Card.Text>
                    {texts && <div className="texto">{texts}</div>}
                    {numbers && <div className="numero">{numbers}</div>}
                </Card.Text>
            </Card.Body>
        </Card>
      )
}
